import { Status } from './status';
import { Transcript } from './transcript';
import { AudioPlayer } from './audioPlayer';

export const AiScribe = {
  Status,
  Transcript,
  AudioPlayer
};

export { Status, Transcript, AudioPlayer };
